import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../actions/participants.action'
import destroyParticipant from 'api/administration/participants/Delete'
import I18n from 'i18n'
import { ErrorToast } from 'components/ui/toast/toastsTemplates'

async function deleteParticipant(id: number) {
  return await destroyParticipant(id)
}

function* participantsDestroyEffectSaga(action: any) {
  try {
    const { data } = yield call(deleteParticipant, action.payload)
    yield put(fromActions.Actions.participantsProfilesDestroySuccess(data))
    yield put(fromActions.Actions.participantsProfilesReload())
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.genericError'))
    console.log('error: ', error)
  }
}

export function* participantsDestroyWatcherSaga() {
  yield takeLatest(fromActions.PARTICIPANTS_PROFILES_DESTROY, participantsDestroyEffectSaga)
}
